export * from './lib/dashboard.providers';
export * from './lib/dashboard.routes';
export * from './lib/dashboard.shared';

export * from './lib/widgets/kundeninfo-widget/kundeninfo-widget.providers';
